import { createFileRoute } from '@tanstack/react-router'
import { RoutineList } from '@/features/routines/RoutineList'
import { PageHeading } from '@/components/PageHeading'

export const Route = createFileRoute('/routines')({
  component: RoutinesPage,
})

function RoutinesPage() {
  return (
    <div className="py-6 sm:py-8">
      <PageHeading title="Routines" meta="Sequences you repeat" />
      <div className="mt-6">
        <RoutineList />
      </div>
    </div>
  )
}
